<template>

    <small class="text-danger">
        <span v-if="showError">Campo obrigatório </span>
        <span v-if="emailError">O E-mail deve ser Valido </span>
        <span v-if="matchesError"> A senha deve atender aos requisitos de complexidade </span>
        <span v-if="oneOfError">As senhas devem coincidir </span>
    </small>
 
</template>
<script>
export default {
    props: ['showError', 'emailError', 'matchesError', 'oneOfError']
}
</script>
<style scoped>
    small {
        display: flex;
        gap: 8px;
        position: absolute;
        left: 5px;
        bottom: 0;
    }
</style>